import PropTypes from 'prop-types';
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Chip from '@material-ui/core/Chip';
import Property from '../../Property';

const MetadataSimpleArray = ({ label, value }) => (
  <Property
    label={label}
    value={
      value && (
        <Grid container spacing={1}>
          {value.map(tag => (
            <Grid item key={tag}>
              <Chip label={tag} />
            </Grid>
          ))}
        </Grid>
      )
    }
  />
);

MetadataSimpleArray.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.array,
};

MetadataSimpleArray.defaultProps = {
  value: [],
};

export default MetadataSimpleArray;
